import { ExamPaperListContent } from './ExamPaperListContent';
export default ExamPaperListContent;